<form [formGroup]="form">
  <p-accordion [value]="activeAttributeIndex">
    @for (
      attribute of attributesControls();
      track attribute;
      let index = $index
    ) {
      <p-accordion-panel [value]="index">
        <p-accordion-header>
          <div class="me-4 flex flex-1 items-center justify-between gap-4">
            <div class="flex items-center gap-2 text-sm text-gray-400">
              <div class="flex gap-1 font-bold">
                <span>#{{ index + 1 }}</span>
                <span>
                  {{
                    labelForGroup(attribute)
                      | async
                      | adminDictionaryProductAttributeLabel
                      | async
                  }}
                </span>
              </div>
            </div>

            <div>
              <p-button
                (onClick)="handleRemoveClick(index)"
                appPrimengButton
                label="Usuń"
                severity="danger" />
            </div>
          </div>
        </p-accordion-header>

        <p-accordion-content>
          <div class="flex flex-col">
            <app-form-control label="Atrybut produktu">
              <p-select
                [filter]="true"
                [formControl]="attribute.controls.productAttributeId"
                [options]="
                  valueOrDefault(productAttributeSelectItems$ | async, [])
                "
                appPrimengSelect
                [fluid]="true"
                placeholder="Wybierz atrybut produktu" />
            </app-form-control>

            <app-form-control label="Treść atrybutu">
              <app-summernote
                [height]="120"
                [formControl]="attribute.controls.content" />
            </app-form-control>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    } @empty {
      <div class="rounded-sm border border-gray-200 p-4">
        <div class="mb-2 italic">Brak atrybutu produktu.</div>

        <p-button
          (onClick)="handleAddClick()"
          [fluid]="true"
          appPrimengButton
          label="Dodaj atrybut produktu"
          size="small" />
      </div>
    }

    @if (isNotEmptyArray(attributesControls())) {
      <div class="mt-3 flex flex-col">
        <p-button
          (onClick)="handleAddClick()"
          [fluid]="true"
          appPrimengButton
          label="Dodaj atrybut produktu"
          size="small" />
      </div>
    }
  </p-accordion>
</form>
